// ** Package ngrx-immer is not compatible with current version of Angular and Store **

import { ReducerTypes, ActionReducer, ActionCreator, ActionType, on } from '@ngrx/store';
import { Draft } from 'immer';

import { produce } from 'immer';

/**
 * Helper method that wraps a reducer with the Immer `produce` method
 * Kudos to Alex Okrushko {@link https://lookout.dev/rules/simple-immer-base-function-to-be-used-in-ngrx-store-or-componentstore-for-transforming-data-%22mutably%22}
 */
export function immerReducer<State, Next>(callback: (state: State, next: Next) => State | void) {
  return (state: State | undefined, next: Next) => {
    return produce(state, (draft: State) => callback(draft, next)) as State;
  };
}

/**
 * An immer reducer that allows a void return
 */
export type ImmerOnReducer<State, AC extends ActionCreator[]> = (state: Draft<State>, action: ActionType<AC[number]>) => void;

/**
 * Immer wrapper around `on` to mutate state
 * Kudos to Tim Deschryver {@link https://github.com/timdeschryver/ngrx-immer/blob/main/src/store/index.ts}
 */
export function immerOn<State, Creators extends ActionCreator[]>(
  ...args: [...creators: Creators, reducer: ImmerOnReducer<State extends infer S ? S : never, Creators>]
): ReducerTypes<State, Creators> {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  const reducer = args.pop() as Function as ActionReducer<State>;
  return (on as any)(...(args as ActionCreator[]), immerReducer(reducer));
}
